module.exports = __webpack_public_path__ + "img/p1.7a2c1bb6.png";